module.exports = __webpack_public_path__ + "img/mountain_giant_small.043a1e6d.png";